export const isElementChildOf = (parent: Node, child: Node) => {
  let node = child.parentNode;
  while (node !== null) {
    if (node === parent) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
};


export const reappend = (element: HTMLElement) => {
  if (!element.parentNode) return;

  element.parentNode.appendChild(element);
};
